export const SCRIPT_SOURCE = 'https://public-sdk.thecloudgate.io/sdk/cloud/Twc.plugin.js';

export const CONFIG = {
  FBK: {
    brandKey: '20250929075047805goOe5KwVwx86nBEhPoA',
    scenarioId: 'NDA5Mw==',
  },
  '3PL_NFA': {
    brandKey: '202509290751195kBK1zv6aJpBSwr-zNcKlA',
    scenarioId: 'NDA5NA==',
  },
} as const;

export const BUTTON_OPTION = {
  showLauncher: true,
  zIndex: 10,
  bottom: 25,
  right: 25,
} as const;
